var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs flex items-center justify-left py-1"},[_c('inertia-link',{attrs:{"href":"/"}},[_vm._v("Dashboard")]),_vm._v(" "),_c('i',{staticClass:"fad fa-chevron-right"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }